import { EDUCATION_GROUP_ID } from 'common/constants/ProductConstants'

export const isEducationGroup = group => group.customId === EDUCATION_GROUP_ID
